import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';

import { ProdutoService } from '../services/produto.service';
import { FornecedorService } from '../services/fornecedor.service';
import { GrupoProdutoService } from '../services/grupo-produto.service';
import { ExcelService } from '../services/excel.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-produto-saldo',
  templateUrl: './produto-saldo.component.html',
  styleUrls: ['./produto-saldo.component.css'],
  animations: [loadingFade, modal, alert] 
})
export class ProdutoSaldoComponent implements OnInit {
  public loading = false;

  // paginacao
	public page = 1;
	public limit = 10;
	public count = 0;
	
	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public filtered = false;
	public formFiltro: FormGroup;
	public showFilter = true;
	public fornecedores;
	public gruposProduto;
	public produtos;


	constructor(private fb: FormBuilder,
							private produtoSvc: ProdutoService,
							private fornecedorSvc: FornecedorService,
							private grupoProdutoSvc: GrupoProdutoService,
							private excelSvc: ExcelService,
							) { }

  ngOnInit() {
		//this.pegaFornecedores();
		//this.pegaGruposProduto();
		this.pegaProdutos();
		this.criaFiltro();
	}
	
	criaFiltro() {
		this.formFiltro = this.fb.group({
			produto_codigo___produto_codigo: '',
			produto_descricao___produto_descricao: '',
			fornecedor_id___fornecedor_id: null,
			grupo_produto_id___grupo_produto_id: null,
			produto_valor___valorMin: '',
			produto_valor___valorMax: '',
			produto_qtd___produto_qtd: ''
		});
	}

	pegaFornecedores(){
    this.fornecedorSvc.getFornecedores().then((data: any) => {
      this.fornecedores = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaGruposProduto(){
    this.grupoProdutoSvc.getGruposProduto().then((data: any) => {
      this.gruposProduto = data;
    }).catch((err) => {
      console.log(err);
    });
	}
	
	pegaProdutos(){
		this.loading = true;
		this.produtoSvc.getProdutos().then((data: any) => {
			this.produtos = data;
			this.count = this.produtos.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroPipe().transform(this.produtos, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.filtered = true;
		this.page = 1;
	}


  expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaProduto(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.produtoSvc.apagaProduto(id).then((data) => {
					this.pegaProdutos();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.produtos;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Cód.' : this.dadosFiltrados[index].produto_codigo,
				'Descrição' : this.dadosFiltrados[index].produto_descricao,
				'Fornecedor' : this.dadosFiltrados[index].fornecedor.fornecedor_nome,
				'Localização' : this.dadosFiltrados[index].produto_localizacao,
				'Mín.' : this.dadosFiltrados[index].produto_qtd_min + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Entr.' : this.dadosFiltrados[index].qtd_entradas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Saída' : this.dadosFiltrados[index].qtd_saidas + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Qtde.' : this.dadosFiltrados[index].produto_qtd_saldo + ' ' + this.dadosFiltrados[index].unidade_medida.unidade_medida_codigo,
				'Nível' : this.dadosFiltrados[index].produto_nivel,
				'Compra' : String(this.dadosFiltrados[index].total_entradas).replace('.', ','),
				'Venda' : String(this.dadosFiltrados[index].total_saidas).replace('.', ','),
				'Lucro' : this.dadosFiltrados[index].produto_lucro + '%',
				'Saldo' : String(this.dadosFiltrados[index].produto_valor_saldo).replace('.', ',')
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Produtos');
	}
}
